import {
  Box,
  Paper,
  InputBase,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  Switch,
  Pagination,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { FaPlus } from "react-icons/fa";
// import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import LoadingOverlay from "../../mui/LoadingOverlay";
import { deleteuserdata, fetchusers, Updateuserdata } from "../../api/apiAdmin";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteuserModal from "./DeleteuserModal";
import {
  Addusers,
  selectusers,
  deleteuser,
  updateusers,
} from "../../redux/usersSlice";
import { UpdateuserModal } from "./UpdateuserModal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectAdmin, selectDevice } from "../../redux/adminSlice";
import { selectgroups } from "../../redux/businessSlice";
import WarningModal from "../WarningModal";
import { orgwarndata } from "../../redux/websocketSlice";

function UserList() {
  const deviceId = useSelector(selectDevice);
  const [loading, setLoading] = useState(false);
  const [userid, setUserId] = useState();
  const warndata = useSelector(orgwarndata);
  const [opendelete, setOpendelete] = useState(false);
  const [openupdate, setOpenUpdate] = useState(false);
  const [updatedata, setUpdate] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [operationLoading, setOperationLoading] = useState(false);
  const dispatch = useDispatch();
  // const alluser = useSelector(selectusers) || [];
  const admin = useSelector(selectAdmin) || {};
  const [childOrganizations, setChildOrganizations] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [data, setData] = useState([]);
  // //// console.log(alluser);
  const groups = useSelector(selectgroups);
  const groupfilter = (id) => {
    if (!Array.isArray(groups)) {
      return "";
    }
    const data = groups.find((item) => item._id === id);
    // //// console.log(data,"this is group data for groupname");

    return data?.businessNature || "";
  };
  const requestIdRef = useRef(0);
  const fetchUserList = useCallback(async () => {
    const requestId = ++requestIdRef.current;
    try {
      setLoading(true);
      const response = await fetchusers(page, pageSize, debouncedSearch);
      if (requestId !== requestIdRef.current) return; // ignore stale response
      if (response?.status === 200) {
        const payload = Array.isArray(response.data?.data)
          ? response.data.data
          : response.data?.users || [];
        const filtered = (Array.isArray(payload) ? payload : [])?.filter(
          (u) => u?._id !== admin?._id
        );
        dispatch(Addusers(filtered));
        setTotal(response.data?.total ?? filtered.length);
        setData(filtered);
        setChildOrganizations(filtered);
      } else if (response?.status === 403) {
        dispatch(Addusers([]));
        setTotal(0);
        setData([]);
        setChildOrganizations([]);
        toast.error("Permission denied");
      }
    } catch (error) {
      if (requestId !== requestIdRef.current) return;
      console.error("Error fetching users:", error);
      dispatch(Addusers([]));
      setTotal(0);
      setData([]);
      setChildOrganizations([]);
    } finally {
      if (requestId === requestIdRef.current) setLoading(false);
    }
  }, [page, pageSize, dispatch, admin?._id, debouncedSearch]);

  useEffect(() => {
    fetchUserList();
  }, [fetchUserList]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPage(1);
    }, 300); // wait before updating

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const deleteData = async () => {
    try {
      setOpendelete(false);
      setOperationLoading(true);
      const response = await deleteuserdata(userid);
      console.log("response", response);
      if (response.status === 200) {
        dispatch(deleteuser(userid));
        toast.success("User deleted successfully");
        // Refetch user list to ensure data consistency
        await fetchUserList();
      } else if (response.status === 403) {
        toast.error(response.data.message);
      } else {
        toast.error(response?.data?.message || "Failed to delete user");
      }
    } catch (error) {
      toast.error("Error deleting user");
      console.error("Error deleting user:", error);
    } finally {
      setOperationLoading(false);
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query !== "") {
      const filtered = data?.filter((org) =>
        (org.firstName + " " + org.lastName)
          .toLowerCase()
          .includes(query.toLowerCase())
      );
      setChildOrganizations(filtered);
    } else {
      setChildOrganizations(data);
    }
  };

  const handleToggleVerification = async (userId, isVerified) => {
    try {
      setOperationLoading(true);
      const response = await Updateuserdata(userId, {
        isVerified: !isVerified, // Toggle the current value
      });

      if (response && response.status === 200) {
        dispatch(updateusers(response.data.data));
        toast.success(
          `User ${!isVerified ? "verified" : "unverified"} successfully`
        );
        // Refetch user list to ensure data consistency
        await fetchUserList();
      } else {
        toast.error("Failed to update user status");
      }
    } catch (error) {
      toast.error("Failed to update user status");
      console.error("Error updating verification status:", error);
    } finally {
      setOperationLoading(false);
    }
  };

  return (
    <>
      <div>
        <div className="add-new d-flex align-items-end justify-content-end"></div>

        <div className="p-sm-3">
          <div>
            <h3 className="fw-bold">Users</h3>
            <div className="row mb-md-0 mb-2">
              <div className="col-md-6">
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search User"
                    inputProps={{ "aria-label": "Search User" }}
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>
              {admin.userRole === "Admin" && (
                <div className="col-md-6 d-flex justify-content-end gap-2">
                  <span>
                    <span className="m-2">
                      <Link
                        to={"/admin/Createuser"}
                        className="btn text-white"
                        style={{
                          backgroundColor: "#003B93",
                          minWidth: "150px",
                        }}
                      >
                        <FaPlus /> Add User
                      </Link>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div style={{ position: "relative", minHeight: "400px" }}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "400px",
                  }}
                >
                  <CircularProgress size={50} sx={{ color: "#003B93" }} />
                </Box>
              ) : childOrganizations.length > 0 ? (
                <TableContainer sx={{ marginTop: 5 }} component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="user table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="fw-bold">ID</TableCell>
                        <TableCell className="fw-bold">User Name</TableCell>
                        <TableCell className="fw-bold">Email</TableCell>
                        <TableCell className="fw-bold">
                          Business Group
                        </TableCell>
                        <TableCell className="fw-bold">User Role</TableCell>
                        <TableCell className="fw-bold">
                          Verification Status
                        </TableCell>
                        <TableCell className="fw-bold">Status</TableCell>
                        {admin?.permissions.editUser && (
                          <TableCell className="fw-bold">Edit</TableCell>
                        )}
                        {admin?.permissions.deleteUser && (
                          <TableCell className="fw-bold">Delete</TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {childOrganizations?.map((row, index) => (
                        <TableRow key={row._id}>
                          <TableCell>
                            {(page - 1) * pageSize + index + 1}
                          </TableCell>
                          <TableCell>
                            {row.firstName + " " + row.lastName}
                          </TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{groupfilter(row.businessType)}</TableCell>
                          <TableCell>{row.userRole}</TableCell>
                          <TableCell>
                            <Box display="flex" alignItems="center">
                              <Switch
                                checked={row.isVerified || false}
                                onChange={() =>
                                  handleToggleVerification(
                                    row._id,
                                    row.isVerified
                                  )
                                }
                                color="primary"
                                disabled={
                                  !admin?.permissions.editUser || loading
                                }
                              />
                              <Typography variant="body2" ml={1}>
                                {row.isVerified ? "Verified" : "Pending"}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.isDeleted ? "red" : "green",
                              fontWeight: "bold", // optional for emphasis
                            }}
                          >
                            {row.isDeleted ? "Deleted" : "Active"}
                          </TableCell>

                          {admin?.permissions.editUser && (
                            <TableCell>
                              <Button
                                onClick={() => {
                                  setOpenUpdate(true);
                                  setUpdate(row);
                                  dispatch({
                                    type: "alertchange",
                                    payload: {
                                      id: row?._id,
                                      message:
                                        "Another users also edit this business group",
                                    },
                                  });
                                }}
                                variant="contained"
                                style={{ backgroundColor: "rgb(0, 59, 147)" }}
                              >
                                Edit
                              </Button>
                            </TableCell>
                          )}
                          {admin?.permissions.deleteUser && (
                            <TableCell>
                              <DeleteIcon
                                style={{
                                  fontSize: "30px",
                                  color: "rgb(0, 59, 147)",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setOpendelete(true);
                                  setUserId(row._id);
                                }}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : null}
            </div>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Box display="flex" alignItems="">
                <Pagination
                  count={Math.ceil((total || 0) / pageSize) || 1}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
              <Typography mt={2} variant="body2" color="textSecondary">
                Total Users: {total}
              </Typography>
              <Select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setPage(1);
                }}
                size="small"
                sx={{
                  color: "#003B93",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "#003B93",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#003B93",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#003B93",
                  },
                  ".MuiSvgIcon-root": { color: "#003B93" },
                }}
              >
                {[5, 10, 20, 50, 100, 200]?.map((n) => (
                  <MenuItem key={n} value={n}>
                    {n}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </div>
        </div>
      </div>
      <DeleteuserModal
        open={opendelete}
        handleClose={() => setOpendelete(false)}
        handleDelete={deleteData}
      />
      <LoadingOverlay open={operationLoading} />
      {openupdate && (
        <UpdateuserModal
          open={openupdate}
          onClose={() => {
            setOpenUpdate(false);
            dispatch({
              type: "alertremove",
              payload: {
                id: updatedata?._id,
                message: "Another users also edit this business group",
              },
            });
          }}
          data={updatedata}
          setChildOrganizations={setChildOrganizations}
          setData={setData}
          refetchUserList={fetchUserList}
        />
      )}
      {openupdate &&
        updatedata?._id === warndata?.objId &&
        warndata?.users?.filter((item) => item !== admin?._id + "-" + deviceId)
          .length > 0 && (
          <WarningModal
            setOpen={setOpenUpdate}
            setNodeData={setData}
            users={warndata?.users}
            usersInfo={warndata?.usersInfo || []}
            nodeId={warndata?.objId}
          />
        )}
    </>
  );
}

export default UserList;
